import React from 'react';

const PageIdLink = ({id}) => (
    <>
        <a href={`#page-anchor-${id.replace(/\W/g, '_')}`} className="page-id-link badge badge-primary">{id}</a>
    </>
);

export default PageIdLink;
